export default "__VITE_ASSET__846597ed__"